import * as React from "react";

import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import {
  getWeeklyWinners,
  getSeasonWinnersThroughWeek,
} from "../api/FantasyAPI";
import WinnersTable from "./WinnersTable";
import EmailModal from "./EmailModal";
import { styled } from "@mui/system";
import { getYears, getMostRecentNFLSeasonAndWeek } from "../utils/utils";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

export const Header = styled("div")({
  color: "#102a43",
  fontSize: "1.25rem",
  fontWeight: "800",
  letterSpacing: "-0.02em",
  marginBottom: "14px",
});

export default function WeeklyWinners() {
  const years = getYears();
  const [year, setYear] = React.useState("");
  const [week, setWeek] = React.useState("");
  const [weekWinners, setWeekWinners] = React.useState([]);
  const [seasonWinners, setSeasonWinners] = React.useState([]);
  const [emailModalOpen, setEmailModalOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [loadingEmail, setLoadingEmail] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const handleYearChange = (event) => {
    setYear(event.target.value);
  };
  const handleWeekChange = (event) => {
    setWeek(event.target.value);
  };

  const handleSeasonChange = () => {
    if (year !== "" && week !== "") {
      setLoadingEmail(true);
      getSeasonWinnersThroughWeek(year, week)
        .then((res) => {
          setSeasonWinners(res);
        })
        .finally(() => setLoadingEmail(false));
    }
  };

  React.useEffect(() => {
    const fetchMostRecentWeek = async () => {
      try {
        const mostRecent = await getMostRecentNFLSeasonAndWeek();
        setYear(mostRecent.season);
        if (mostRecent.week > 17) {
          setWeek(17);
        } else {
          setWeek(mostRecent.week);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchMostRecentWeek();
  }, []);
  React.useEffect(() => handleSeasonChange(), [year, week]);
  React.useEffect(() => {
    if (year !== "" && week !== "") {
      handleSubmit();
    }
  }, [year, week]);

  const handleSubmit = () => {
    console.log(`Fetching winners for Year: ${year}, Week: ${week}`);
    setLoading(true);
    getWeeklyWinners(year, week)
      .then((res) => {
        setWeekWinners(res);
        console.log(res);
      })
      .catch((error) => {
        setErrorMessage("Could not load the weekly winners.");
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCloseError = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setError(false);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Header>Week Winners</Header>
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <InputLabel id="select-year-label" size="small">
          Year
        </InputLabel>
        <Select
          labelId="select-year-label"
          id="select-year"
          value={year}
          label="Year"
          onChange={handleYearChange}
          size="small"
          MenuProps={MenuProps}
        >
          {years.map((year, i) => (
            <MenuItem key={i} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <InputLabel id="select-week-label" size="small">
          Week
        </InputLabel>
        <Select
          size="small"
          labelId="select-week-label"
          id="select-week"
          value={week}
          label="Week"
          onChange={handleWeekChange}
          MenuProps={MenuProps}
        >
          {Array(17)
            .fill(0)
            .map((_, i) => (
              <MenuItem key={i} value={i + 1}>
                {i + 1}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <FormControl sx={{ m: 1, minWidth: 120 }}>
        {
          <Button
            disabled={!weekWinners || weekWinners.length === 0}
            onClick={() => setEmailModalOpen(true)}
          >
            Draft Email
          </Button>
        }
      </FormControl>

      <WinnersTable winners={weekWinners} loading={loading} season={false} />

      <EmailModal
        open={emailModalOpen}
        loading={loadingEmail}
        setOpen={setEmailModalOpen}
        weekWinners={weekWinners}
        seasonWinners={seasonWinners}
        year={year}
        week={week}
      />

      <Snackbar open={error} autoHideDuration={6000} onClose={handleCloseError}>
        <Alert
          onClose={handleCloseError}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
